<div [formGroup]="form" class="tool-list" *ngIf="isCalculated">
    <mat-tree [dataSource]="treedataSource" [treeControl]="treeControl" class="tree_button" *ngIf="treedataSource.data.length > 0">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" id="{{ node.id }}" class="dropdown-tree" (click)="SelectedTool(node)" matTreeNodePadding>
            <!-- use a disabled button to provide padding for tree leaf -->
            <button mat-button>{{ node.name }}</button>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" class="dropdown-tree active" matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle id="{{ node.id }}" [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>
            {{ node.name }}
        </mat-tree-node>
    </mat-tree>
    <div *ngIf="treedataSource.data.length == 0">
        <span class="info-message">{{ 'CALC_OUTPUT.TOOL_OUTPUT.NO_TOOL' | transloco }}</span>
    </div>
</div>
